module.exports = __webpack_public_path__ + "img/placeholder-412.5780e7a7.jpg";